const page1 = require("../images/mmi-help/2020-04-14_Summary.jpg");
const recurringServices = require("../images/mmi-help/2020-04-14_Recurring_Summary.jpg");
const variableServices = require("../images/mmi-help/2020-04-14_Variable_Summary.jpg");
const recurringServiceTax = require("../images/mmi-help/2020-04-14_Recurring_Detail_cons.png");
const configuration = [
  {
    id: 1,
    section: "Page 1 Summary",
    description: "Show the site detail on the summary page of the invoice",
    image: page1,
    summary: {
      type: "bool",
      key: "summarySum",
      value: true
    },
    detail: {
      type: "bool",
      key: "summaryDet",
      value: true
    }
  },
  {
    id: 2,
    section: "Recurring services Summary",
    description:
      "Show the recurring services summary section on the invoice (detail invoice only)",
    image: recurringServices,
    summary: {
      type: "text",
      key: null,
      value: "N/A"
    },
    detail: {
      type: "bool",
      key: "recurSumDet",
      value: true
    }
  },
  {
    id: 3,
    section: "Variable Services Summary",
    description: "Show the variable services summary section on the invoice",
    image: variableServices,
    summary: {
      type: "bool",
      key: "variableSum",
      value: true
    },
    detail: {
      type: "bool",
      key: "variableDet",
      value: true
    }
  },
  {
    id: 4,
    section: "Recurring Service Changes & One-Time Charges Detail",
    description:
      "Show the line item tax detail on the recurring services summary section of the invoice (detail invoice only)",
    image: recurringServiceTax,
    summary: {
      type: "text",
      key: null,
      value: "N/A"
    },
    detail: {
      type: "bool",
      key: "recurSvcDet",
      value: false
    }
  }
];

export default configuration;
